import { LitElement, css, html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import type { ChatStatus } from "../types.js";

@customElement("help-jonas-status")
export class HelpJonasStatus extends LitElement {
  static override styles = css`
    :host {
      display: block;
      color: var(--color-foreground-700);
    }
  `;

  @property()
  accessor status: ChatStatus = "idle";

  @property()
  accessor error = "";

  @property()
  accessor retryQuestion = "";

  @property()
  accessor retryLabel = "Vraag opnieuw stellen";

  protected override render() {
    if (this.error) {
      return html`<afas-alert type="danger"
        >${this.error}${this.retryQuestion
          ? html`<afas-button
              variant="ghost"
              .label=${this.retryLabel}
              @click=${() =>
                this.dispatchEvent(
                  new CustomEvent("jonas-retry-question", {
                    detail: { question: this.retryQuestion },
                    bubbles: true,
                    composed: true,
                  }),
                )}
            ></afas-button>`
          : nothing}</afas-alert
      >`;
    }
    // The preparing, streaming, and stopped states all render inside the assistant
    // bubble (help-jonas-chat-message): the preparing indicator, the streamed answer,
    // and — when the user stops — a localized cancellation notice. The status row would
    // only duplicate them, so it stays empty for every non-error state — and takes up no
    // room either, so the disclaimer of the last answer is not held away from the
    // composer by a row that only ever fills on an error.
    return html`<span aria-live="polite"></span>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "help-jonas-status": HelpJonasStatus;
  }
}
